wbApp.factory('preferredBookingSvc', ['$resource', '$q', '$translate', 'notificationSvc', 'repositorySvc',
    function ($resource, $q, $translate, notificationSvc, repositorySvc) {

        var PreferredBooking = $resource('/Api/PreferredBooking/Get', {}, {
            'getBySemesterID': { method: 'GET', isArray: false, url: '/Api/PreferredBooking/GetBySemesterID' },
            'getByPreferredBooking': { method: 'POST', isArray: false, url: '/Api/PreferredBooking/GetByPreferredBooking' },
            'update': { method: 'POST', url: '/Api/PreferredBooking/Update' },
            'insert': { method: 'POST', url: '/Api/PreferredBooking/Insert' },
        });

        function createNew(semesterID) {
            return {
                preferredBookingID: 0,
                semesterID: semesterID,
                sourceSemestersIDs: [],
                data: []
            };
        }

        function getBySemesterID(semesterID) {
            return repositorySvc.customGet(
                'getBySemesterID',
                PreferredBooking,
                {
                    semesterID: semesterID
                });
        }

        function getByPreferredBooking(model) {
            return PreferredBooking['getByPreferredBooking'](
                {
                    dto: model
                });
        }

        function insert(data, successCallback, errorCallback) {
            repositorySvc.insert(
                PreferredBooking,             // $resource
                null,            // collection
                data,                 // entity
                successCallback,
                errorCallback);
        }

        function update(data, successCallback, errorCallback) {
            repositorySvc.update(
                PreferredBooking,            // $resource
                null,           // collection
                data,                // entity
                successCallback,
                errorCallback,
                'preferredBookingID');
        }

        return {
            createNew: createNew,
            insert: insert,
            update: update,
            getBySemesterID: getBySemesterID,
            getByPreferredBooking: getByPreferredBooking
        }
    }
]);
